import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../ui/Button';
import { Eye } from 'lucide-react' 
import { toast } from 'react-toastify';
import { useLoading } from '../../contexts/LoadingContext';
import { useLoginUser } from '../../hooks/db/useLogin';
import { useGetConversations } from '../../hooks/db/useGetConversations';
import { getConversationTitle } from '../../lib/common';

const Conversations: React.FC = () => {
    const { getConversations } = useGetConversations()
    const navigate = useNavigate()
    const [conversations, setConversations] = useState<Record<string, any>[]>([])
    const { forgotPasswordUser } = useLoginUser()
    const { setLoading } = useLoading()

    useEffect(() => {
        const fetchConversations = async () => {
            setLoading(true)
            try {
                const result = await getConversations()
                if (result && 'conversations' in result) {
                    setConversations((result as { conversations: any }).conversations)
                }
            } catch (error) {
                if ((error as Error).name === 'AbortError') {
                    console.log("Fetch aborted");
                } else {
                    console.error("Error fetching conversations:", error);
                }
            }finally{
                setLoading(false)
            }
        }
        fetchConversations()
    }, [])

    const handleView = (row: any) => {
        navigate(`/admin/conversations/${row._id}`)
    }

    return (
        <div>
            <div className="flex justify-between items-center mb-4">
            <h2 className="text-xl font-bold">Conversations</h2>
            </div>
            <div className="overflow-x-auto">
                <table className="min-w-full table-auto border border-gray-200 text-left text-sm">
                    <thead className="bg-gray-200">
                        <tr>
                            <th className="px-4 py-2 border-b font-semibold text-gray-700">Title</th>
                            <th className="px-4 py-2 border-b font-semibold text-gray-700">ConvId</th>
                            <th className="px-4 py-2 border-b font-semibold text-gray-700">User</th>
                            <th className="px-4 py-2 border-b font-semibold text-gray-700">Created At</th>
                            <th className="px-4 py-2 border-b font-semibold text-gray-700">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {conversations.map((row, index) => (
                            <tr key={index} className=" hover:bg-gray-50 dark:hover:bg-gray-900">
                                <td className="px-4 py-2 border-b capitalize">{getConversationTitle(row)}</td>
                                <td className="px-4 py-2 border-b">{row.botpressId}</td>
                                <td className="px-4 py-2 border-b capitalize">{row.user?.name || 'N/A'}</td>
                                <td className="px-4 py-2 border-b">{new Date(row.createdAt).toLocaleString()}</td>
                                <td className="px-4 py-2 border-b">
                                    <div className="flex space-x-2">
                                        <Button
                                            variant="outline"
                                            size="sm"
                                            onClick={() => handleView(row)}
                                            className="text-gray-800"
                                            title="View Conversation"
                                        >
                                            <Eye className="h-4 w-4 mr-1" />
                                        </Button>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default Conversations